:root {
  --color-bg: #0f1115;
  --color-surface: #171a21;
  --color-border: #262b36;
  --color-text: #e8eaed;
  --color-muted: #9aa3b2;
  --color-accent: #6ea8fe;

  font-family:
    system-ui,
    -apple-system,
    'Segoe UI',
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
  line-height: 1.5;
  color-scheme: dark light;
}

@media (prefers-color-scheme: light) {
  :root {
    --color-bg: #f7f8fa;
    --color-surface: #ffffff;
    --color-border: #e3e6ea;
    --color-text: #1b1f24;
    --color-muted: #5b6675;
    --color-accent: #0b5ed7;
  }
}

* {
  box-sizing: border-box;
}

html,
body,
#root {
  height: 100%;
}

body {
  margin: 0;
  background: var(--color-bg);
  color: var(--color-text);
  -webkit-font-smoothing: antialiased;
}

a {
  color: var(--color-accent);
}
